/* 🤖 this file was generated by svg-to-ts */
export const svgPlus: {
    name: "plus";
    data: string;
} = {
    name: "plus",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__plus" viewBox="0 0 12 12"><path id="ng__path-plus" fill="none" fill-rule="evenodd" stroke-linecap="round" d="M6 2v8M10 6H2"/></symbol></svg>`,
};
